export const SET_CURRENT_TAB = 'SET_CURRENT_TAB';
export const SET_SIDEBAR_VISIBLE = 'SET_SIDEBAR_VISIBLE';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_TOAST = 'SET_TOAST';
export const SET_ROLES = 'SET_ROLES';
export const SET_LOGO = 'SET_LOGO';
export const SET_SHIPS = 'SET_SHIPS';
export const SET_SHIPS_FROM_VOP = 'SET_SHIPS_FROM_VOP';

export const SET_INSPECTION_FIRST_STEP = 'SET_INSPECTION_FIRST_STEP';
export const SET_INSPECTION_DATA = 'SET_INSPECTION_DATA';
export const SET_CURRENT_TAB_ACTION_PLAN = 'SET_CURRENT_TAB_ACTION_PLAN';

export const SET_INSPECTION_LIST_DETAILS = 'SET_INSPECTION_LIST_DETAILS';
export const SET_DECK_IMAGE = 'SET_DECK_IMAGE';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';

// {
//   inspectionData: {firstStep: {inspectionCode: '', zoneName: ''}},
// };
